import EstimateForm from './EstimateForm';
import HeroSection from './HeroSection';
import PartnersFooter from './PartnersFooter';
import ProgramDetails from './ProgramDetails';

export default function LandingPage() {
  return (
    <div className="landing-page bg-light" id="top">
      <HeroSection />

      <main className="main ">
        <ProgramDetails />
        <EstimateForm />
      </main>

      <PartnersFooter />
    </div>
  );
}
